import React, {Component} from "react";
import UrlsContainer from "../../../components/TaskMining/UrlsContainer.jsx";
import {API} from "../../../lib/API";
import ModalDialog from "../../../components/Common/ModalDialog";
import KnoaBreadcrumb from "../../../components/Common/KnoaBreadcrumb";
import {mauiRoutes} from "../../../routes";
import {withTranslation} from 'react-i18next';
import Spinner from "../../../components/Common/Spinner";
import {Redirect} from "react-router-dom";
import {getSpecificOPErrorMessages} from "../../../lib/notifications/messageUtils";
import {notifyWithMessage} from "../../../lib/notifications/notifyWithMessage";
import {Helmet} from "react-helmet";
import {Row} from "react-bootstrap";

const localStorage = require('../../../lib/localStorage');

class AdminUrlConfigurationPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            allMappings: [],
            discovered: 0,
            showModal: false,
            fetchInProgress: "true",
            showLoggedoutModal: false,
            sessionTerminated: false
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.updateAllMappings = this.updateAllMappings.bind(this);
    }

    handleShow(e) {
        e.preventDefault();

        this.setState({
            showModal: true
        });
    }

    handleClose() {
        this.setState({
            showModal: false
        });
    }

    updateAllMappings(mappings) {
        this.setState({
            allMappings: mappings
        });
    }

    componentDidMount() {
        const _this = this;
        API.admin
            .get("/admin/gtm/configuration/app/mapping")
            .then(resp => {
                const {data} = resp.data;
                console.log(data)
                _this.setState({
                    allMappings: data.mappings,
                    discovered: data.applicationLevels,
                    fetchInProgress: "false"
                });
            })
            .catch(e => {
                console.error(e);
                if (localStorage.get("accessDenied401") === "true") {
                    _this.setState({showLoggedoutModal: true});
                    return;
                }
                let resultCode = -1;
                if (e.data) {
                    resultCode = e.data.resultCode;
                }
                if (e.status === 401 || resultCode === 6007)
                    window.location.href = "/#/auth/logout"
                if (resultCode > -1) {
                    notifyWithMessage({type: 'error', t: _this.props.t, resultCode, isNormal: true});
                } else {
                    notifyWithMessage({type: 'error', t: _this.props.t, errorObject: e, isNormal: true});
                }

                _this.setState({
                    fetchInProgress: "false"
                });
            });
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState({allMappings: [],});
        this.setState({discovered: 0,});
    }


    render() {
        if (this.state.sessionTerminated)
            return <Redirect to={{pathname: '/auth/logout'}}/>;

        let routes = mauiRoutes.getRoutes();
        const {t} = this.props;

        return (
            <div className="main-content">
                <Helmet>
                    <title>Knoa Analytics - Task Mining Configuration</title>
                </Helmet>
                <div >
                    <Row className="user-admin-breadcrumb">
                        <KnoaBreadcrumb
                            href="#/admin/AllSettings"
                            firstLevelText={t("common:settings")}
                            secondLevelText={(this.props.navVarBrand) ? this.props.navVarBrand : this.props.getActiveRoute(routes, t)}
                        />
                    </Row>
                    {this.state.showLoggedoutModal && (
                    <ModalDialog
                        showModal={this.state.showLoggedoutModal}
                        title={"Log Out"}
                        contentBody={
                            <span>{getSpecificOPErrorMessages(this.props.t,"logoutfor401",null,null)}</span>
                        }
                        bodyPaddingBottom='15px'
                        footerBtnBsStyle="success"
                        footerBtnClass="KnoaSuccessButton"
                        footerBtnOnClick={this.handleLogoutConfirm}
                        footerBtnText={this.props.t('common:ok')}
                    />
                    )}
                    {this.state.fetchInProgress === "true" && <Spinner/>}
                    <div hidden={this.state.fetchInProgress === "true"}>
                        {this.state.fetchInProgress === "false" &&
                        <UrlsContainer
                            title={t("gtm:title")}
                            allMappings={this.state.allMappings}
                            discovered = {this.state.discovered}
                            handleShow={this.handleShow}
                            updateAllMappings={this.updateAllMappings}
                        />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default  withTranslation()(AdminUrlConfigurationPage);